// Mock data for Hoffmann Haustechnik website

export const companyInfo = {
  name: "Hoffmann Haustechnik",
  owner: "Stefan Bruns-Hoffmann",
  slogan: "Heizung • Sanitär • Erneuerbare Energien",
  address: {
    street: "Pariser Straße 34",
    zip: "55286",
    city: "Wörrstadt",
    country: "Deutschland"
  },
  phone: "06732 964808",
  phoneLink: "tel:+496732964808",
  emergency: "0171 4803234",
  emergencyLink: "tel:+491714803234",
  email: "info@hoffmann-heizung.de",
  emailLink: "mailto:info@hoffmann-heizung.de",
  founded: 2003,
  plusInstallateurLogo: "/images/buderus-partner.png",
  logo: "/images/logo.png"
};

export const images = {
  team: "/images/team.jpg",
  vehicles: "/images/vehicles.jpg",
  heroBathroom: "https://images.unsplash.com/photo-1696987007764-7f8b85dd3033?w=1400&q=75&fm=jpg",
  bathroom2: "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=900&q=75&fm=jpg",
  bathroom3: "https://images.unsplash.com/photo-1769356814886-abdadde25ea7?w=900&q=75&fm=jpg",
  heating: "https://images.unsplash.com/photo-1600210492493-0946911123ea?w=900&q=75&fm=jpg",
  heating2: "https://images.unsplash.com/photo-1726090401458-7abb00f7450c?w=900&q=75&fm=jpg",
  solar: "https://images.unsplash.com/photo-1558449028-b53a39d100fc?w=900&q=75&fm=jpg",
  solar2: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=900&q=75&fm=jpg",
  solar3: "https://images.unsplash.com/photo-1724041875334-0a6397111c7e?w=900&q=75&fm=jpg",
  smartHome: "https://images.unsplash.com/photo-1558002038-1055907df827?w=900&q=75&fm=jpg",
  smartHome2: "https://images.unsplash.com/photo-1513584684374-8bab748fbf90?w=900&q=75&fm=jpg",
  smartHome3: "https://images.pexels.com/photos/29091470/pexels-photo-29091470.jpeg?auto=compress&w=900",
  technician: "https://images.pexels.com/photos/35290669/pexels-photo-35290669.jpeg?auto=compress&w=900",
  technician2: "https://images.pexels.com/photos/35290670/pexels-photo-35290670.jpeg?auto=compress&w=900",
  homeInterior: "https://images.pexels.com/photos/28456461/pexels-photo-28456461.jpeg?auto=compress&w=1200",
  office: "https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?auto=compress&w=900",
};

export const services = [
  {
    id: "heizung",
    title: "Heizung & Wärme",
    shortDesc: "Moderne Heizungsanlagen für optimalen Komfort und maximale Energieeffizienz. Professionelle Beratung, Installation und Wartung.",
    icon: "Flame",
    link: "/heizung",
    features: [
      "Gas- und Ölheizungen",
      "Wärmepumpen",
      "Fußbodenheizung",
      "Heizungsmodernisierung",
      "Wartung & Reparatur",
      "Hydraulischer Abgleich"
    ]
  },
  {
    id: "bad",
    title: "Bad & Sanitär",
    shortDesc: "Professionelle Sanitärinstallationen und Badgestaltung für Ihr Zuhause. Qualität und Design, die überzeugen.",
    icon: "Droplets",
    link: "/bad-sanitaer",
    features: [
      "Badplanung & Badgestaltung",
      "Sanitärinstallation",
      "Badsanierung",
      "Barrierefreie Bäder",
      "Wasseraufbereitung",
      "Rohrsanierung"
    ]
  },
  {
    id: "regenerativ",
    title: "Regenerative Energien",
    shortDesc: "Innovative und umweltfreundliche Energielösungen für nachhaltiges Heizen und eine grüne Zukunft.",
    icon: "Sun",
    link: "/regenerative-energien",
    features: [
      "Solarthermie",
      "Photovoltaik",
      "Wärmepumpen",
      "Pelletheizungen",
      "Fördermittelberatung",
      "Energieberatung"
    ]
  },
  {
    id: "smarthome",
    title: "Smart Home",
    shortDesc: "Intelligente Haustechnik für maximalen Komfort und Effizienz. Steuern Sie Ihr Zuhause per App – jederzeit und überall.",
    icon: "Wifi",
    link: "/smart-home",
    features: [
      "Intelligente Thermostate",
      "App-Steuerung",
      "Automatisierung",
      "Energiemanagement",
      "Vernetzung aller Systeme",
      "Fernwartung"
    ]
  },
  {
    id: "klima",
    title: "Klima & Lüftung",
    shortDesc: "Professionelle Klimaanlagen und Lüftungssysteme für angenehmes Raumklima – im Sommer kühl, im Winter warm.",
    icon: "Wind",
    link: "/klima",
    features: [
      "Klimaanlagen",
      "Lüftungssysteme",
      "Split-Klimageräte",
      "Wartung & Service",
      "Luftqualität",
      "Energieeffiziente Kühlung"
    ]
  }
];

export const klimaDetails = {
  title: "Klima & Lüftung",
  subtitle: "Professionelle Klimatechnik für Ihr Wohlbefinden",
  intro: "Ob Klimaanlage, Lüftungsanlage oder Split-Klimagerät – wir sorgen für das perfekte Raumklima in Ihrem Zuhause oder Betrieb. Professionelle Beratung, Installation und Wartung aus einer Hand.",
  sections: [
    {
      id: "klima-installation",
      title: "Klimaanlagen & Split-Geräte",
      text: "Wir installieren moderne Klimaanlagen und Split-Klimageräte aller führenden Hersteller. Ob Einzel- oder Multisplit-Lösung – wir finden die perfekte Klimatisierung für Ihre Räume.",
      features: ["Split-Klimaanlagen", "Multisplit-Systeme", "Decken- & Wandgeräte", "Inverter-Technologie"]
    },
    {
      id: "klima-lueftung",
      title: "Lüftungssysteme",
      text: "Eine gute Lüftung ist essentiell für Gesundheit und Wohlbefinden. Wir planen und installieren zentrale und dezentrale Lüftungsanlagen mit Wärmerückgewinnung.",
      features: ["Zentrale Lüftung", "Dezentrale Lüftung", "Wärmerückgewinnung", "Pollenfilter"]
    },
    {
      id: "klima-wartung",
      title: "Wartung & Service",
      text: "Regelmäßige Wartung sichert die Effizienz und Langlebigkeit Ihrer Klimaanlage. Unser Serviceteam kümmert sich um Inspektion, Reinigung und Kältemittelcheck.",
      features: ["Jährliche Inspektion", "Filterwechsel", "Kältemittelprüfung", "Reparaturservice"]
    }
  ]
};

export const heizungDetails = {
  title: "Heizung & Wärme",
  subtitle: "Effiziente Heiztechnik für Ihr Zuhause",
  intro: "Als Meisterbetrieb sorgen wir dafür, dass Ihr Zuhause warm und gemütlich bleibt – mit modernster Heiztechnik, die Energie spart und die Umwelt schont.",
  sections: [
    {
      id: "heizung-installation",
      title: "Heizungsinstallation",
      text: "Wir installieren alle gängigen Heizsysteme – von der klassischen Gas- und Ölheizung bis hin zu modernen Wärmepumpen und Pelletheizungen. Dabei achten wir stets auf höchste Qualität und Effizienz.",
      features: ["Gasbrennwerttechnik", "Ölbrennwerttechnik", "Wärmepumpen", "Pellet- & Holzheizungen"]
    },
    {
      id: "heizung-modernisierung",
      title: "Heizungsmodernisierung",
      text: "Alte Heizungsanlagen verbrauchen unnötig viel Energie. Wir modernisieren Ihre bestehende Anlage und helfen Ihnen, bis zu 30% Energiekosten einzusparen.",
      features: ["Energieberatung", "Austausch alter Kessel", "Optimierung bestehender Anlagen", "Fördermittelberatung"]
    },
    {
      id: "heizung-wartung",
      title: "Wartung & Service",
      text: "Regelmäßige Wartung verlängert die Lebensdauer Ihrer Heizung und sorgt für einen effizienten Betrieb. Unser Wartungsservice umfasst alle gängigen Hersteller.",
      features: ["Jährliche Wartung", "Notdienst", "Ersatzteilversorgung", "Schnelle Erreichbarkeit"]
    }
  ]
};

export const badDetails = {
  title: "Bad & Sanitär",
  subtitle: "Ihr Traumbad – von der Planung bis zur Umsetzung",
  intro: "Wir verwandeln Ihr Badezimmer in eine Wohlfühloase. Von der ersten Idee bis zur fertigen Installation – alles aus einer Hand.",
  sections: [
    {
      id: "bad-planung",
      title: "Badplanung & Design",
      text: "Gemeinsam mit Ihnen planen wir Ihr individuelles Traumbad. Dabei berücksichtigen wir Ihre Wünsche, den vorhandenen Raum und Ihr Budget.",
      features: ["3D-Badplanung", "Materialberatung", "Barrierefreie Konzepte", "Individuelle Lösungen"]
    },
    {
      id: "bad-installation",
      title: "Sanitärinstallation",
      text: "Von der Wasserleitung bis zum Abfluss – unsere erfahrenen Installateure sorgen für eine fachgerechte und saubere Installation aller sanitären Anlagen.",
      features: ["Wasserinstallation", "Abwassertechnik", "Rohrsanierung", "Leckagenortung"]
    },
    {
      id: "bad-wasserqualitaet",
      title: "Wasserqualität",
      text: "Sauberes Trinkwasser ist uns wichtig. Wir bieten Wasseranalysen und Aufbereitungssysteme für Ihr Zuhause an.",
      features: ["Wasseranalyse", "Enthärtungsanlagen", "Filtersysteme", "Trinkwasserhygiene"]
    }
  ]
};

export const regenerativDetails = {
  title: "Regenerative Energien",
  subtitle: "Nachhaltig heizen – die Zukunft beginnt jetzt",
  intro: "Setzen Sie auf erneuerbare Energien und machen Sie sich unabhängig von fossilen Brennstoffen. Wir beraten Sie kompetent zu allen Möglichkeiten.",
  sections: [
    {
      id: "regen-solar",
      title: "Solarthermie & Photovoltaik",
      text: "Nutzen Sie die Kraft der Sonne für Warmwasser, Heizungsunterstützung und Stromerzeugung. Wir planen und installieren Ihre Solaranlage.",
      features: ["Solarthermie-Anlagen", "Photovoltaik-Systeme", "Speicherlösungen", "Eigenverbrauchsoptimierung"]
    },
    {
      id: "regen-waermepumpen",
      title: "Wärmepumpen",
      text: "Wärmepumpen nutzen die kostenlose Umweltwärme aus Luft, Erde oder Wasser. Eine der effizientesten Heizlösungen auf dem Markt.",
      features: ["Luft-Wasser-Wärmepumpen", "Sole-Wasser-Wärmepumpen", "Wasser-Wasser-Wärmepumpen", "Hybridlösungen"]
    },
    {
      id: "regen-foerder",
      title: "Fördermittel & Beratung",
      text: "Für den Umstieg auf erneuerbare Energien gibt es attraktive staatliche Förderungen. Wir helfen Ihnen, alle verfügbaren Fördermittel zu nutzen.",
      features: ["BAFA-Förderung", "KfW-Förderprogramme", "Landesförderprogramme", "Individuelle Beratung"]
    }
  ]
};

export const smartHomeDetails = {
  title: "Smart Home",
  subtitle: "Intelligente Haustechnik für mehr Komfort",
  intro: "Vernetzen Sie Ihre Haustechnik und steuern Sie alles bequem per App. Wir machen Ihr Zuhause intelligent.",
  sections: [
    {
      id: "smart-steuerung",
      title: "Intelligente Steuerung",
      text: "Steuern Sie Heizung, Lüftung und Warmwasser bequem über Ihr Smartphone oder Tablet – von überall und zu jeder Zeit.",
      features: ["App-Steuerung", "Sprachsteuerung", "Zeitprogramme", "Szenarien-Management"]
    },
    {
      id: "smart-energie",
      title: "Energiemanagement",
      text: "Optimieren Sie Ihren Energieverbrauch durch intelligente Steuerung. Sparen Sie Energie und Kosten, ohne auf Komfort zu verzichten.",
      features: ["Verbrauchsanalyse", "Optimierungsvorschläge", "Solarkopplung", "Lastmanagement"]
    },
    {
      id: "smart-vernetzung",
      title: "Vernetzung & Integration",
      text: "Wir integrieren alle Ihre haustechnischen Systeme in ein zentrales Smart-Home-System für maximale Effizienz.",
      features: ["Systemintegration", "Nachrüstung", "Fernwartung", "Updates & Support"]
    }
  ]
};

export const karriereData = {
  title: "Karriere bei Hoffmann Haustechnik",
  intro: "Werden Sie Teil unseres Teams! Wir suchen motivierte Mitarbeiter, die mit uns die Zukunft der Haustechnik gestalten möchten.",
  jobs: [
    {
      id: "job-anlagenmechaniker",
      title: "Anlagenmechaniker/in SHK (m/w/d)",
      type: "Vollzeit",
      description: "Wir suchen erfahrene Anlagenmechaniker für Sanitär-, Heizungs- und Klimatechnik für unser wachsendes Team.",
      requirements: ["Abgeschlossene Ausbildung als Anlagenmechaniker SHK", "Führerschein Klasse B", "Teamfähigkeit und Zuverlässigkeit", "Eigenverantwortliches Arbeiten"]
    },
    {
      id: "job-azubi",
      title: "Auszubildende/r Anlagenmechaniker/in SHK (m/w/d)",
      type: "Ausbildung",
      description: "Starte Deine Karriere im Handwerk! Wir bilden Dich zum/zur Anlagenmechaniker/in für Sanitär-, Heizungs- und Klimatechnik aus.",
      requirements: ["Hauptschulabschluss oder höher", "Technisches Interesse", "Handwerkliches Geschick", "Teamgeist"]
    }
  ],
  benefits: [
    "Familiäres Arbeitsumfeld",
    "Moderne Werkzeuge & Fahrzeuge",
    "Fort- und Weiterbildungen",
    "Faire Vergütung",
    "30 Tage Urlaub",
    "Betriebliche Altersvorsorge"
  ]
};

export const heizungsrechnerData = {
  buildingTypes: [
    { id: "efh", label: "Einfamilienhaus", factor: 1.0 },
    { id: "mfh", label: "Mehrfamilienhaus", factor: 0.85 },
    { id: "rh", label: "Reihenhaus", factor: 0.9 },
    { id: "wohnung", label: "Wohnung", factor: 0.8 }
  ],
  insulationLevels: [
    { id: "schlecht", label: "Schlecht (vor 1978)", factor: 150 },
    { id: "mittel", label: "Mittel (1978-1995)", factor: 100 },
    { id: "gut", label: "Gut (1995-2015)", factor: 70 },
    { id: "sehrgut", label: "Sehr gut (nach 2015 / KfW)", factor: 45 }
  ],
  heatingTypes: [
    { id: "gas", label: "Gas", costPerKwh: 0.12, co2PerKwh: 0.201 },
    { id: "oel", label: "Öl", costPerKwh: 0.13, co2PerKwh: 0.266 },
    { id: "waermepumpe", label: "Wärmepumpe", costPerKwh: 0.08, co2PerKwh: 0.06 },
    { id: "pellet", label: "Pelletheizung", costPerKwh: 0.06, co2PerKwh: 0.036 },
    { id: "solar", label: "Solar + Wärmepumpe", costPerKwh: 0.05, co2PerKwh: 0.03 }
  ]
};

export const impressumData = {
  company: "Hoffmann Haustechnik",
  owner: "Stefan Bruns-Hoffmann",
  address: "Pariser Straße 34\n55286 Wörrstadt\nDeutschland",
  phone: "06732 964808",
  email: "info@hoffmann-heizung.de",
  responsible: "Stefan Bruns-Hoffmann",
  euStreitschlichtung: "https://ec.europa.eu/consumers/odr",
  content: [
    {
      title: "Angaben gemäß § 5 DDG",
      text: "Hoffmann Haustechnik\nInhaber: Stefan Bruns-Hoffmann\nPariser Straße 34\n55286 Wörrstadt\nDeutschland\n\nTelefon: 06732 964808\nE-Mail: info@hoffmann-heizung.de\n\nHandwerkskammer: Handwerkskammer Rheinhessen\nBerufsbezeichnung: Anlagenmechaniker für Sanitär-, Heizungs- und Klimatechnik (Meisterbetrieb)\nZuständige Kammer: Handwerkskammer Rheinhessen, Dagobertstraße 2, 55116 Mainz"
    },
    {
      title: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
      text: "Stefan Bruns-Hoffmann\nAnschrift wie oben"
    },
    {
      title: "EU-Streitschlichtung",
      text: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr\n\nUnsere E-Mail-Adresse finden Sie oben im Impressum.\n\nWir sind weder verpflichtet noch bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen."
    },
    {
      title: "Haftung für Inhalte",
      text: "Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.\n\nVerpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt."
    },
    {
      title: "Haftung für Links",
      text: "Unsere Website enthält ggf. Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für diese fremden Inhalte übernehmen wir keine Gewähr."
    },
    {
      title: "Urheberrecht",
      text: "Die durch uns erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers."
    }
  ]
};

export const datenschutzData = {
  title: "Datenschutzerklärung",
  stand: "28. Februar 2026",
  intro: "Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Nachfolgend informieren wir Sie transparent darüber, welche Daten wir erheben, wie wir sie verwenden und welche Rechte Ihnen zustehen.",
  sections: [
    {
      title: "1. Verantwortlicher",
      text: "Hoffmann Haustechnik\nInhaber: Stefan Bruns-Hoffmann\nPariser Straße 34\n55286 Wörrstadt\nDeutschland\n\nTelefon: 06732 964808\nE-Mail: info@hoffmann-heizung.de"
    },
    {
      title: "2. Allgemeine Hinweise zur Datenverarbeitung",
      text: "Wir verarbeiten personenbezogene Daten ausschließlich im Rahmen der geltenden gesetzlichen Vorschriften, insbesondere:\n\n• Datenschutz-Grundverordnung (DSGVO)\n• Bundesdatenschutzgesetz (BDSG)\n• Telekommunikation-Digitale-Dienste-Datenschutz-Gesetz (TDDDG)\n\nPersonenbezogene Daten sind alle Informationen, mit denen Sie persönlich identifiziert werden können (z. B. Name, Telefonnummer, E-Mail-Adresse, IP-Adresse)."
    },
    {
      title: "3. Ihre Rechte als betroffene Person",
      text: "Sie haben jederzeit folgende Rechte:\n\n• Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)\n• Berichtigung unrichtiger Daten (Art. 16 DSGVO)\n• Löschung Ihrer Daten (Art. 17 DSGVO)\n• Einschränkung der Verarbeitung (Art. 18 DSGVO)\n• Datenübertragbarkeit (Art. 20 DSGVO)\n• Widerspruch gegen bestimmte Verarbeitungen (Art. 21 DSGVO)\n• Widerruf einer Einwilligung mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO)\n\nZudem steht Ihnen ein Beschwerderecht bei einer Datenschutzaufsichtsbehörde zu."
    },
    {
      title: "4. Datensicherheit",
      text: "Unsere Website nutzt eine SSL-/TLS-Verschlüsselung. Darüber hinaus treffen wir technische und organisatorische Maßnahmen, um Ihre Daten gegen Manipulation, Verlust oder unbefugten Zugriff zu schützen."
    },
    {
      title: "5. Zugriffsdaten (Server-Logfiles)",
      text: "Beim Aufruf unserer Website werden automatisch folgende Daten erfasst:\n\n• IP-Adresse\n• Datum und Uhrzeit des Zugriffs\n• Aufgerufene Seite/Datei\n• Referrer-URL\n• Browsertyp und Betriebssystem\n\nDiese Daten dienen ausschließlich der Sicherstellung eines störungsfreien Betriebs, der Gewährleistung der IT-Sicherheit und der technischen Fehleranalyse.\n\nRechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)."
    },
    {
      title: "6. Kontaktaufnahme",
      text: "Wenn Sie uns per E-Mail, Telefon oder über ein Kontaktformular kontaktieren, verarbeiten wir Ihre Angaben ausschließlich zur Bearbeitung Ihrer Anfrage.\n\nVerarbeitete Daten können sein: Name, Telefonnummer, E-Mail-Adresse, Inhalt Ihrer Nachricht.\n\nRechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) oder Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an Kommunikation)."
    },
    {
      title: "7. Cookies und Einwilligungsmanagement",
      text: "Unsere Website kann Cookies verwenden. Es wird unterschieden zwischen technisch notwendigen Cookies (für den Betrieb der Website erforderlich) und optionalen Cookies (z. B. Statistik oder Marketing).\n\nNicht notwendige Cookies werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt. Sie können Ihre Einwilligung jederzeit über die Cookie-Einstellungen widerrufen oder anpassen."
    },
    {
      title: "8. Einbindung externer Dienste",
      text: "a) Google Maps\nAuf unserer Kontaktseite nutzen wir den Kartendienst Google Maps (Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland). Die Karte wird erst nach Ihrer ausdrücklichen Einwilligung über unser Cookie-Banner geladen. Beim Laden werden Ihre IP-Adresse und weitere technische Daten an Google übermittelt. Es kann zu einer Datenübermittlung in die USA kommen. Google ist unter dem EU-U.S. Data Privacy Framework zertifiziert.\n\nRechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO (Einwilligung).\n\nOhne Einwilligung wird keine Verbindung zu Google hergestellt. Stattdessen wird die Adresse als Text angezeigt.\n\nb) Externe Bilddienste\nFür die Bebilderung unserer Website verwenden wir teilweise Bilder von externen Diensten (z. B. Unsplash, Pexels). Beim Laden dieser Bilder kann Ihre IP-Adresse an den jeweiligen Anbieter übermittelt werden.\n\nc) Schriftarten\nAlle auf unserer Website verwendeten Schriftarten (Inter, Playfair Display) werden lokal von unserem Server geladen. Es findet keine Verbindung zu Google Fonts oder anderen externen Schriftarten-Diensten statt."
    },
    {
      title: "9. Weitergabe von Daten",
      text: "Eine Weitergabe Ihrer personenbezogenen Daten erfolgt nur, wenn dies zur Vertragserfüllung erforderlich ist, wenn wir gesetzlich dazu verpflichtet sind, oder wenn Sie ausdrücklich eingewilligt haben."
    },
    {
      title: "10. Speicherdauer",
      text: "Personenbezogene Daten werden nur so lange gespeichert, wie es für den jeweiligen Zweck erforderlich ist oder gesetzliche Aufbewahrungsfristen bestehen."
    },
    {
      title: "12. Lokale Speicherung (Local Storage)",
      text: "Unsere Website nutzt die lokale Speicherfunktion Ihres Browsers (Local Storage und Session Storage) für folgende Zwecke:\n\n• Speicherung Ihrer Cookie-Einwilligung\n• Zwischenspeicherung von Websiteinhalten zur Beschleunigung der Ladezeiten (Session Storage)\n\nDiese Daten werden ausschließlich in Ihrem Browser gespeichert und nicht an uns übermittelt. Sie können diese Daten jederzeit über die Einstellungen Ihres Browsers löschen."
    },
    {
      title: "13. Keine automatisierte Entscheidungsfindung",
      text: "Eine automatisierte Entscheidungsfindung oder ein Profiling findet nicht statt."
    },
    {
      title: "14. Aktualität dieser Datenschutzerklärung",
      text: "Diese Datenschutzerklärung ist aktuell gültig (Stand Februar 2026). Wir behalten uns vor, sie bei Änderungen der Rechtslage oder unseres Angebots anzupassen."
    }
  ]
};
